import { Layout, Select, Popover, Avatar } from 'antd';
import { useEffect, useState } from 'react';
import i18n from '../../i18n/i18n';

import MiniProfile from './component/mini-profile';
import ModalRelease from './component/ModalRelease';

import { useAuthContext } from '../../context/auth-context';
import GlobalService from '../../services/Global.service';
import UserService from '../../services/UserService';


const { Header } = Layout;

const { Option } = Select;

const HeaderLayout = () => {
    const [language, setLanguage] = useState('en');
    const [miniprofileOpen, setMiniprofileOpen] = useState(false);

    const { username } = useAuthContext();
    const [releaseList, setReleaseList] = useState([]);
    const [openRelease, setOpenRelease] = useState(false);

    function handleChange(value) {
        setLanguage(value);
        i18n.changeLanguage(value);
        localStorage.setItem('i18nextLng', value);
    }

    const getRelease = async () => {
        try {
            const { data } = await GlobalService.getReleaseList();
            if (data?.resultData) {
                console.log(data?.resultData)
                setReleaseList(data?.resultData);
                setOpenRelease(true);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handelClearRelease = async () => {
        setOpenRelease(false);
    };

    function handleChangeRelease(value) {
        if (value === 'manual') {
            const currentPackage = UserService.currentPackage();
            switch (currentPackage) {
                case 1:
                    window.open('https://coda.io/d/Cookie-Management_d_XpRLldifG/Introduction-to-Cookie-Management_sunG_#_luieX', '_blank');
                    break;
                case 2:
                    window.open('https://coda.io/d/WhiteFact-User-Manual-PDPA-Starter_d-pw8C-WKG8', '_blank');
                    break;
                case 3:
                    window.open('https://coda.io/d/WhiteFact-User-Manual-PDPA-Professional_dBNH1HvU3D1', '_blank');
                    break;
                case 4:
                    window.open('https://coda.io/d/WhiteFact-User-Manual-Business-Enterprise_dfJP0PQEcdt', '_blank');
                    break;
                default:
                    // temp default manual remove later when custom manual done
                    window.open('https://coda.io/d/WhiteFact-User-Manual-professional_dBNH1HvU3D1', '_blank');
                    break;
            }
        } else {
            getRelease();
        }
    }

    useEffect(() => {
        const lang = localStorage.getItem('i18nextLng');
        setLanguage(lang);
    }, []);

    return (
        <>
            <Header className="site-layout-background p-0 mb-5 pl-0">
                <nav
                    className="px-6 rounded dark:bg-gray-800"
                    style={{ backgroundColor: '#F9FAFE' }}
                >
                    <div className="flex justify-end items-center w-full mx-auto">
                        <div>
                            <ul className="flex gap-x-4 text-sm font-medium mb-0 list-none">
                                <li className="cursor-pointer">
                                    <Popover
                                        trigger="click"
                                        open={miniprofileOpen}
                                        placement="bottom"
                                        content={
                                            <MiniProfile
                                                setMiniprofileOpen={
                                                    setMiniprofileOpen
                                                }
                                                username={
                                                    localStorage.getItem('name')
                                                        ? localStorage.getItem(
                                                            'name'
                                                        )
                                                        : username
                                                }
                                            />
                                        }
                                        onClick={() => {
                                            if (miniprofileOpen) {
                                                setMiniprofileOpen(false);
                                            } else {
                                                setMiniprofileOpen(true);
                                            }
                                        }}
                                        onFocus={() => {
                                            setMiniprofileOpen(false);
                                        }}
                                        onOpenChange={(e) => {
                                            setMiniprofileOpen(e);
                                        }}

                                    // trigger="click"
                                    >
                                        <Avatar
                                            className="cursor-pointer"
                                            style={{
                                                backgroundColor: '#EEE5FF',
                                                color: '#7B67FB',
                                            }}
                                        >
                                            {localStorage.getItem('name')
                                                ? localStorage.getItem('name')[0]
                                                : username[0]}
                                        </Avatar>
                                        <span className="pl-2">
                                            {localStorage.getItem('name')
                                                ? localStorage.getItem('name')
                                                : username}
                                        </span>
                                    </Popover>
                                </li>
                                <li
                                    style={{
                                        borderLeft: '1px solid #95A0A8',
                                        height: '21px',
                                        marginTop: '21px',
                                    }}
                                ></li>
                                <li className="flex items-center">
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M8 15.5C6.975 15.5 6.00625 15.303 5.09375 14.909C4.18125 14.5155 3.3845 13.978 2.7035 13.2965C2.022 12.6155 1.4845 11.8188 1.091 10.9062C0.697 9.99375 0.5 9.025 0.5 8C0.5 6.9625 0.697 5.99075 1.091 5.08475C1.4845 4.17825 2.022 3.3845 2.7035 2.7035C3.3845 2.022 4.18125 1.48425 5.09375 1.09025C6.00625 0.69675 6.975 0.5 8 0.5C9.0375 0.5 10.0092 0.69675 10.9152 1.09025C11.8217 1.48425 12.6155 2.022 13.2965 2.7035C13.978 3.3845 14.5155 4.17825 14.909 5.08475C15.303 5.99075 15.5 6.9625 15.5 8C15.5 9.025 15.303 9.99375 14.909 10.9062C14.5155 11.8188 13.978 12.6155 13.2965 13.2965C12.6155 13.978 11.8217 14.5155 10.9152 14.909C10.0092 15.303 9.0375 15.5 8 15.5ZM8 13.9625C8.325 13.5125 8.60625 13.0438 8.84375 12.5563C9.08125 12.0688 9.275 11.55 9.425 11H6.575C6.725 11.55 6.91875 12.0688 7.15625 12.5563C7.39375 13.0438 7.675 13.5125 8 13.9625ZM6.05 13.6625C5.825 13.25 5.62825 12.8217 5.45975 12.3778C5.29075 11.9342 5.15 11.475 5.0375 11H2.825C3.1875 11.625 3.6405 12.1687 4.184 12.6312C4.728 13.0937 5.35 13.4375 6.05 13.6625ZM9.95 13.6625C10.65 13.4375 11.2717 13.0937 11.8153 12.6312C12.3593 12.1687 12.8125 11.625 13.175 11H10.9625C10.85 11.475 10.7095 11.9342 10.541 12.3778C10.372 12.8217 10.175 13.25 9.95 13.6625ZM2.1875 9.5H4.7375C4.7 9.25 4.67175 9.003 4.65275 8.759C4.63425 8.5155 4.625 8.2625 4.625 8C4.625 7.7375 4.63425 7.4845 4.65275 7.241C4.67175 6.997 4.7 6.75 4.7375 6.5H2.1875C2.125 6.75 2.078 6.997 2.0465 7.241C2.0155 7.4845 2 7.7375 2 8C2 8.2625 2.0155 8.5155 2.0465 8.759C2.078 9.003 2.125 9.25 2.1875 9.5ZM6.2375 9.5H9.7625C9.8 9.25 9.82825 9.003 9.84725 8.759C9.86575 8.5155 9.875 8.2625 9.875 8C9.875 7.7375 9.86575 7.4845 9.84725 7.241C9.82825 6.997 9.8 6.75 9.7625 6.5H6.2375C6.2 6.75 6.172 6.997 6.1535 7.241C6.1345 7.4845 6.125 7.7375 6.125 8C6.125 8.2625 6.1345 8.5155 6.1535 8.759C6.172 9.003 6.2 9.25 6.2375 9.5ZM11.2625 9.5H13.8125C13.875 9.25 13.922 9.003 13.9535 8.759C13.9845 8.5155 14 8.2625 14 8C14 7.7375 13.9845 7.4845 13.9535 7.241C13.922 6.997 13.875 6.75 13.8125 6.5H11.2625C11.3 6.75 11.328 6.997 11.3465 7.241C11.3655 7.4845 11.375 7.7375 11.375 8C11.375 8.2625 11.3655 8.5155 11.3465 8.759C11.328 9.003 11.3 9.25 11.2625 9.5ZM10.9625 5H13.175C12.8125 4.375 12.3593 3.83125 11.8153 3.36875C11.2717 2.90625 10.65 2.5625 9.95 2.3375C10.175 2.75 10.372 3.178 10.541 3.6215C10.7095 4.0655 10.85 4.525 10.9625 5ZM6.575 5H9.425C9.275 4.45 9.08125 3.93125 8.84375 3.44375C8.60625 2.95625 8.325 2.4875 8 2.0375C7.675 2.4875 7.39375 2.95625 7.15625 3.44375C6.91875 3.93125 6.725 4.45 6.575 5ZM2.825 5H5.0375C5.15 4.525 5.29075 4.0655 5.45975 3.6215C5.62825 3.178 5.825 2.75 6.05 2.3375C5.35 2.5625 4.728 2.90625 4.184 3.36875C3.6405 3.83125 3.1875 4.375 2.825 5Z"
                                            fill="#65707A"
                                        />
                                    </svg>
                                    <Select
                                        value={language}
                                        onChange={handleChange}
                                        bordered={false}
                                        className="w-[95px]"
                                    >
                                        <Option value="th">Thai</Option>
                                        <Option value="en">English</Option>
                                    </Select>
                                </li>
                                <li
                                    style={{
                                        borderLeft: '1px solid #95A0A8',
                                        height: '21px',
                                        marginTop: '21px',
                                    }}
                                ></li>
                                <li className="flex items-center">

                                    <Select
                                        onChange={handleChangeRelease}
                                        bordered={false}
                                        suffixIcon={
                                            <svg
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M6.79688 13.2051C4.88281 12.0977 3.59375 10.0273 3.59375 7.65625C3.59375 4.11914 6.46289 1.25 10 1.25C13.5371 1.25 16.4062 4.11914 16.4062 7.65625C16.4062 10.0273 15.1172 12.0977 13.2031 13.2051V15.4688C13.2031 15.8145 12.9238 16.0938 12.5781 16.0938H7.42188C7.07617 16.0938 6.79688 15.8145 6.79688 15.4688V13.2051ZM7.65625 17.3438H12.3438C12.4297 17.3438 12.5 17.4141 12.5 17.5V18.125C12.5 18.4707 12.2207 18.75 11.875 18.75H8.125C7.7793 18.75 7.5 18.4707 7.5 18.125V17.5C7.5 17.4141 7.57031 17.3438 7.65625 17.3438Z"
                                                    fill="#65707A"
                                                />
                                            </svg>
                                        }

                                        dropdownMatchSelectWidth={false}
                                        style={{ minWidth: "auto" }}
                                        value={null}
                                        placeholder=""
                                    >
                                        <Option className="releaseSelect" value="manual">{language === 'en' ? "User Manual" : "คู่มือการใช้งานระบบ"}</Option>
                                        <Option className="releaseSelect" value="release">{language === 'en' ? "Version Released" : "การอัปเดตเวอร์ชัน"}</Option>
                                    </Select>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </Header>
            <ModalRelease
                open={openRelease}
                handelClose={() => setOpenRelease(false)}
                handelClearRelease={handelClearRelease}
                releaseList={releaseList}
            />
        </>
    );
};

export default HeaderLayout;
